export const socialNetworks = {
    facebook: 'facebook',
    instagram: 'instagram',
    tiktok: 'tiktok',
    website: 'website',
} as const;
